import { Link } from '@lego/klik-ui';
import { CircleQuestion } from '@lego/klik-ui/icons';

export const DocumentationLink = ({ url }: { url?: string }) => {
  return (
    url && (
      <Link aria-label="Open documentation" href={url} isExternal={true}>
        <CircleQuestion />
      </Link>
    )
  );
};
